import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import SalesAndIncome from '../../../../views/SalesAndIncome/SalesAndIncome';

const SalesAndIncomePageRoute = () => {
	return (		
		<Routes>
			<Route
				path=""
				element={<SalesAndIncome />}
			/>			
		</Routes>	
	);
};

export default SalesAndIncomePageRoute;
